import { Injectable } from '@angular/core';
import { EnvConfigService } from '../app/core/services/env-config.service';
import envSettings from '../resources/env-config.json';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class ApiConfiguration {
  rootUrl: string = '';
  ptkUrl: string = '';

  constructor(private envConfigService: EnvConfigService) {}

  getRootUrl(): string {
    let apiUrl: string = '';
    if (this.envConfigService.loaded) {
      apiUrl = this.envConfigService.envConfig.apiUrl;
    } else {
      apiUrl = envSettings?.apiUrl || '';
    }
    return apiUrl;
  }

  getPtkUrl(): string {
    let ptkUrl: string = '';
    if (this.envConfigService.loaded) {
      ptkUrl = this.envConfigService.envConfig.ptkUrl;
    } else {
      ptkUrl = envSettings?.ptkUrl || '';
    }
    return ptkUrl;
  }
}

/**
 * Parameters for `ApiModule.forRoot()`
 */
export interface ApiConfigurationParams {
  rootUrl?: string;
}
